import { I18n } from "@/i18n";

type TKey = StringKey | PluralKey;
type TOptions = { plural?: boolean; values?: { [key: string]: any } };

export default function useI18n() {
  return {
    t(key: TKey, options?: TOptions) {
      return I18n.translate(key, options);
    },
    locale: I18n.locale
  };
}

export function useI18nWithNamespace(namespace = "common" as const) {
  return {
    t(key: CommonStringKey) {
      return I18n.tWithNamespace(key, namespace);
    },
    locale: I18n.locale
  };
}
